// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3Hn2o","name":"ConsentHeader_name__34EJz","birthday":"ConsentHeader_birthday__3kb1A","skeleton":"ConsentHeader_skeleton__1sAYX"};